import locale from 'localization';

export const initialState = {
  username: {
    name: 'username',
    value: localStorage.getItem('username') || '',
    required: true,
    maxLength: 75,
    label: locale.username
  },
  password: {
    name: 'password',
    placeholder: '',
    value: '',
    required: true,
    maxLength: 75,
    label: locale.password
  },
  remember: {
    name: 'remember',
    value: localStorage.getItem('username') ? true : false,
    label: locale.rememberMe
  }
};
